import { useSlider } from "components/SliderContext";
import useActiveItem from "hooks/useActiveItem";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";

const SpecialOffersSlider = ({ list }) => {
  const {activeItem} = useActiveItem();
  const { swiperRef } = useSlider();

  useEffect(() => {
    if (swiperRef.current) {
      swiperRef.current.update();
    }
  }, [activeItem])

  return (
    <Swiper
      onSwiper={(swiper) => {
      swiperRef.current = swiper;
      }}
      slidesPerView={"auto"}
      spaceBetween={9}
      className="special-offers__slider"
    >
      {list.map((item) => (
        <SwiperSlide className="special-offers__slide" key={item.id}>
          <div className="special-offers__slide-pic">
            <img src={item.image} alt="" />
          </div>
          {/* <span className="special-offers__slide-type">Special Offer</span> */}
          <p className="special-offers__slide-name">{item.name}</p>
          <b className="special-offers__slide-price">${item.cost}</b>
          <Link to={`/buypacks?search_id=${item.id}`} className="special-offers__slide-buy">Buy Now</Link>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default SpecialOffersSlider;
